import { useContext } from "react";

import { LeagueNamingContext } from "./LeagueNamingContext";

export const useLeagueNaming = () => {
  return useContext(LeagueNamingContext) ?? "tour";
};
